class Denuncia {
  constructor() {
    
  }
}

export default Denuncia
